module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('form', {
    staticClass: "login-form",
    attrs: {
      "action": ""
    },
    on: {
      "submit": _vm.modifyLogin
    }
  }, [_c('div', {
    staticClass: "form-line"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.mobileNo),
      expression: "param.mobileNo"
    }],
    staticClass: "gwi-ipt",
    attrs: {
      "type": "text",
      "id": "phone-input-new",
      "placeholder": "请输入新手机号码",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.param.mobileNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "mobileNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('verify-code', {
    attrs: {
      "namespace": "ConfirmPhone",
      "url": "/app/user/send",
      "param": _vm.param
    },
    model: {
      value: (_vm.verifyCode),
      callback: function($$v) {
        _vm.verifyCode = $$v
      },
      expression: "verifyCode"
    }
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0.75rem 0.5rem"
    }
  }, [_c('button', {
    staticClass: "btn-ok phone-input-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("确认修改")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54a1cd6a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/profile/ConfirmPhone.vue
// module id = 835
// module chunks = 0